import NavigationWrapper from "utils/NavigationWrapper";
import { AnalyticsActions } from "utils/Analytics";
import { createSelector } from "reselect";

const getStorySlug = (state) => state.route.params.storySlug;
const getChapterKey = (state) => state.route.params.chapterKey;

const getBackButtonClick = createSelector(
  getChapterKey,
  getStorySlug,
  (chapterKey, storySlug) => () => {
    AnalyticsActions.returnToParentChapter();

    if (NavigationWrapper.canGoBack()) {
      NavigationWrapper.goBack();
    } else {
      NavigationWrapper.push("chapter", storySlug, chapterKey);
    }
  },
);

export default getBackButtonClick;
